<template>
  <v-navigation-drawer app floating permanent class="nav_list pt-4 text-center" mini-variant mini-variant-width="88">
    <v-avatar size="56" tile class="my-2"><v-img src="../../assets/img/portal-logo.png"></v-img> </v-avatar>
    <v-list flat dense>
      <v-list-item-group v-model="selectedItem" color="primary" active-class="app_nav">
        <v-list-item v-for="(item, i) in items" :key="i" class="mt-2" :to="item.path">
          <v-list-item-content>
            <v-list-item-avatar class="rounded-lg mb-2" :class="$vuetify.theme.dark ? 'nav_avatar2' : 'nav_avatar'" style="height: 54px; width: 54px">
              <v-icon class="nav_icon" :color="item.color" size="30">{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="nav_title font-weight-regular">{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 超级管理 -->
        <!-- <v-list-item v-if="user && user.uniCode && user.uniCode == '91330108MA2H3MND51'" class="mt-2" @click="toPage()">
          <v-list-item-content>
            <v-list-item-avatar class="rounded-lg mb-2" :class="$vuetify.theme.dark ? 'nav_avatar2' : 'nav_avatar'" style="height: 54px">
              <v-icon class="nav_icon" color="purple" size="30">mdi-cog-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="nav_title font-weight-regular">运维</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <!-- ./超级管理 -->
      </v-list-item-group>
    </v-list>
    <!-- <template v-slot:append>
      <v-btn icon large class="white--text display-sm-none my-6" to="/mine">
        <v-avatar size="55">
          <v-icon size="50" :color="$vuetify.theme.dark ? '' : 'blue lighten-3'">mdi-account-circle</v-icon>
        </v-avatar>
      </v-btn>
    </template> -->
    <!-- <mine ref="modalMine"/> -->
  </v-navigation-drawer>
</template>

<script>
import Storage from "@/commons/storage";
export default {
  // components: { Mine },
  data() {
    return {
      user: {},
      selectedItem: 0,
      items: [
        { text: "首页", path: "/home", icon: "mdi-home", dialog: false, color: "blue" },
        { text: "应用", path: "/serv", icon: "mdi-widgets", dialog: true, color: "orange" },
        { text: "工单", path: "/trade", icon: "mdi-order-bool-ascending-variant", dialog: true, color: "green" },
        { text: "员工", path: "/users", icon: "mdi-account-group-outline", dialog: true, color: "cyan" },
        { text: "资质", path: "/dept-page", icon: "mdi-police-badge-outline", dialog: true, color: "red" },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.user = Storage.get("_wit_acis_users");
    }, 1000);
    this.$forceUpdate(); //强制刷新
  },
  methods: {
    toPage() {
      this.$router.push({ path: "/admin-page", query: {} });
    },
  },
};
</script>
<style lang="scss" scoped>
.v-navigation-drawer__content::-webkit-scrollbar {
  /* 滚动条宽度和高度 */
  width: 4px;
  height: 4px;
}
.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #d4d6d9;
}
.v-navigation-drawer__content::-webkit-scrollbar-track-piece {
  /*滚动条里面轨道*/
  background-color: #fff;
  border-radius: 10px;
}
.nav_list.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0);
}
.nav_list .app_nav .nav_avatar,
.nav_list .app_nav .nav_avatar2 {
  background: #e1eeff;
  color: #358dff;
}
.nav_list .app_nav .nav_icon,
.app_nav .nav_title {
  color: #358dff !important;
}
.nav_list .nav_avatar {
  background: #f3f3f3;
  color: #999999;
}
.nav_list .nav_avatar2 {
  background: #535353;
  color: #999999;
}
.nav_list .nav_title {
  color: #999999;
}
.height_ca {
  max-height: calc(100vh - 32px) !important;
}
</style>